export default __webpack_public_path__ + "static/media/element_spec_22.9cfc0608.jpg";